module.exports = __webpack_public_path__ + "img/gridbg3.a42f47e2.png";